import React from 'react';
import PropTypes from 'prop-types';

const BagIcon = ({ width, height, color }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M0.610732 9.06023C0.794259 7.25614 2.33719 5.88234 4.17989 5.88234H11.8201C13.6628 5.88234 15.2057 7.25613 15.3893 9.06023L15.9758 14.8254C16.2576 17.5959 14.0466 20 11.2169 20H4.78312C1.95342 20 -0.257585 17.5959 0.024247 14.8254L0.610732 9.06023ZM4.17989 8.23528C3.56566 8.23528 3.05134 8.69321 2.99017 9.29458L2.40368 15.0598C2.26277 16.445 3.36827 17.6471 4.78312 17.6471H11.2169C12.6317 17.6471 13.7372 16.445 13.5963 15.0598L13.0098 9.29458C12.9487 8.69321 12.4343 8.23528 11.8201 8.23528H4.17989Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M5.61532 9.41175C6.27567 9.41175 6.81099 9.93847 6.81099 10.5882V11.7647C6.81099 12.4144 7.3463 12.9412 8.00665 12.9412C8.667 12.9412 9.20231 12.4144 9.20231 11.7647V10.5882C9.20231 9.93847 9.73763 9.41175 10.398 9.41175C11.0583 9.41175 11.5936 9.93847 11.5936 10.5882V11.7647C11.5936 13.7139 9.98769 15.2941 8.00665 15.2941C6.02561 15.2941 4.41966 13.7139 4.41966 11.7647V10.5882C4.41966 9.93847 4.95498 9.41175 5.61532 9.41175Z" fill={color} />
    <path d="M9.21586 3.54265V4.69263C9.21586 4.69705 9.21583 4.70146 9.21578 4.70587H11.6072C11.6072 4.70146 11.6072 4.69704 11.6072 4.69263V3.54265C11.6072 1.5861 9.9952 0 8.00673 0C6.01825 0 4.40628 1.5861 4.40628 3.54265V4.69263C4.40628 4.69704 4.40629 4.70146 4.4063 4.70587H6.79768C6.79763 4.70146 6.7976 4.69705 6.7976 4.69263V3.54265C6.7976 2.88559 7.33895 2.35294 8.00673 2.35294C8.67451 2.35294 9.21586 2.88559 9.21586 3.54265Z" fill={color} />
  </svg>
);

BagIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

BagIcon.defaultProps = {
  color: '#18223D',
  height: 20,
  width: 16,
};

export default BagIcon;
